import {Component, ContentChild, ElementRef, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
  selector: 'exg-panel',
  templateUrl: './exg-panel.component.html',
  styles: [
  ]
})
export class ExgPanelComponent implements OnInit {

  @ContentChild('content') content?: TemplateRef<ElementRef>;

  @Input() caption!: string;
  @Input() value!: any;

  id = Math.random().toString(36).substring(2);

  constructor() { }

  ngOnInit(): void {
  }

}
